import dayjs from "dayjs";

import { _helper } from "../../GlobalFunction/dateHelper";

export default function CustomDataGridDateHelper(DateInputValue, localization) {
  return [
    {
      label: localization.equalsOperator,
      value: "equal",
      getApplyFilterFn: (filterItem) => {
        if (!filterItem.value) return null; // Ensure the filter value exists
        const filterDate = dayjs(filterItem.value);
        return (params) => {
          const cellDate = dayjs(params.value);
          return cellDate.isSame(filterDate);
        };
      },
      InputComponent: DateInputValue,
      InputComponentProps: { type: "date" },
      getValueAsString: (value) => dayjs(value).format("DD.MM.YYYY"),
    },
    {
      label: "After",
      value: "after",
      getApplyFilterFn: (filterItem) => {
        if (!filterItem.value) return null;
        const filterDate = dayjs(filterItem.value);
        return (params) => {
          const cellDate = dayjs(params.value);
          return cellDate.isAfter(filterDate);
        };
      },
      InputComponent: DateInputValue,
      InputComponentProps: { type: "date" },
      getValueAsString: (value) =>
        dayjs(value).format(_helper.DateFormateOrganization()),
    },
    {
      label: localization.isOnAfterOperator,
      value: "afterOrEqual",
      getApplyFilterFn: (filterItem) => {
        if (!filterItem.value) return null;
        const filterDate = dayjs(filterItem.value);
        return (params) => {
          const cellDate = dayjs(params.value);
          return cellDate.isAfter(filterDate) || cellDate.isSame(filterDate);
        };
      },
      InputComponent: DateInputValue,
      InputComponentProps: { type: "date" },
      getValueAsString: (value) => dayjs(value).format("DD.MM.YYYY"),
    },
    {
      label: localization.isBeforeOperator,
      value: "before",
      getApplyFilterFn: (filterItem) => {
        const filterDate = dayjs(filterItem.value);
        return (params) => {
          const cellDate = dayjs(params.value);
          return cellDate.isBefore(filterDate);
        };
      },
      InputComponent: DateInputValue,
      InputComponentProps: { type: "date" },
      getValueAsString: (value) => dayjs(value).format("DD.MM.YYYY"),
    },
    {
      label: localization.isOnBeforeOperator,
      value: "beforeOrEqual",
      getApplyFilterFn: (filterItem) => {
        const filterDate = dayjs(filterItem.value);
        return (params) => {
          const cellDate = dayjs(params.value);
          return cellDate.isBefore(filterDate) || cellDate.isSame(filterDate);
        };
      },
      InputComponent: DateInputValue,
      InputComponentProps: { type: "date" },
      getValueAsString: (value) => dayjs(value).format("DD.MM.YYYY"),
    },
    {
      label: localization.isNotOperator,
      value: "notEqual",
      getApplyFilterFn: (filterItem) => {
        const filterDate = dayjs(filterItem.value);
        return (params) => {
          const cellDate = dayjs(params.value);
          return !cellDate.isSame(filterDate);
        };
      },
      InputComponent: DateInputValue,
      InputComponentProps: { type: "date" },
      getValueAsString: (value) => dayjs(value).format("DD.MM.YYYY"),
    },
  ];
}
